/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Profile } from '../profile.model';


export class ProfileEntity {
    item?: Profile; // ecf001
    code?: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): ProfileEntity {
        if (!data) { return instance; }
        if (data.item != null) {instance.item = new Profile().fromJSON(data.item); } // i8
        if (data.code != null) {instance.code = data.code; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return ProfileEntity.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: ProfileEntity) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return ProfileEntity.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: ProfileEntity): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
